import { gql } from "@apollo/client";

// Get evidence requests
export const GET_EVIDENCE_REQUESTS = gql`
  query GetEvidenceRequests($filter: EvidenceRequestFilterInputType!, $page: Int, $limit: Int) {
    getEvidenceRequests(filter: $filter, page: $page, limit: $limit) {
      statusCode
      success
      message
      totalCount
      data {
        id
        evidence_requested_reason
        author_id
        author_type
        author_name
        author_email
        entity_id
        entity_type
        control_id
        status
        rego_valid_from
        rego_valid_till
      }
    }
  }
`;

// Create a new evidence request
export const CREATE_EVIDENCE_REQUEST = gql`
  mutation CreateEvidenceRequest($input: EvidenceRequestCreateInputType!) {
    createEvidenceRequest(input: $input) {
      statusCode
      success
      message
      data {
        id
        evidence_requested_reason
        author_id
        author_type
        author_name
        author_email
        entity_id
        entity_type
        status
        rego_valid_from
        rego_valid_till
      }
    }
  }
`;

// Update evidence request
export const UPDATE_EVIDENCE_REQUEST = gql`
  mutation UpdateEvidenceRequest($input: [EvidenceRequestUpdateInputType]!) {
    updateEvidenceRequest(input: $input) {
      statusCode
      success
      message
      data {
        id
        success
        error
      }
    }
  }
`;
